// extracted by mini-css-extract-plugin
export default {"SnackbarProvider":"SnackbarProvider_SnackbarProvider__998x0"};